module.exports = "<p>\r\n  master-blog works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/blog/master-blog/master-blog.component.html
// module id = ./src/app/components/blog/master-blog/master-blog.component.html
// module chunks = main